module.exports = __webpack_public_path__ + "img/movejapan.3ffc658.png";